import {DataMode, Research} from "../const";


const createPool = (pool) => {
  return {
    id: pool.id,
    title: pool.title,
    coordinates: pool.coordinates,
    catchAreas: pool.catchAreas.map((area) => {
      return {
        id: area.id,
        title: area.title,
        coordinates: area.coordinates,
        region: area.region ? area.region : `MAIN`,
        sources: area.sources.map((sourceItem) => ({
          name: Research[sourceItem.name],
          dataMode: DataMode[sourceItem.dataMode],
          researchSources: sourceItem.researchSources.map((researchSource) => ({
            title: researchSource.title || `Протокол`,
            url: researchSource.url,
          })),
        })),
        researches: area.researches.map((research) => ({
          name: Research[research.name],
          dataMode: DataMode[research.dataMode],
          title: research.title,
          amount: +research.amount,
          notMatch: +research.notMatch,
        })),
      };
    }),
  };
};

const createPools = (pools) => {
  return pools.map((pool) => createPool(pool));
};


export {
  createPool,
  createPools,
};
